module.exports = __webpack_public_path__ + "static/rulebg.8ed79825.png";